export enum ETipoRelatorioEstoque {
    Geral = 1,
    Marca = 2,
    Categoria = 3,
    Fornecedor = 4,
}
